export default {
  namespaced: true,
  state: {
    video: null,
    duration: -1,
    mode: null,
    oneToOneData: {
      sourceVideoId: null,
      ranges: [],
      title: '',
      tag: [],
      series: [],
      news: [],
    },
    oneToManyData: {
      sourceVideoId: null,
      chunks: []
    },
    playRange: null,
  },
  mutations: {
    set(state, data) {
      state[data.key] = data.value
      if(data.key == 'video' && !!state.video) {
        state.oneToOneData.sourceVideoId = state.video.id
        state.oneToManyData.sourceVideoId = state.video.id
      }
    },
    cleanup(state) {
      state.video = null
      state.duration = -1
      state.mode = null
      state.oneToOneData = {
        sourceVideoId: null,
        ranges: [],
        title: '',
        tag: [],
        series: [],
        news: [],
      }

      state.oneToManyData = {
        chunks: []
      }
    },
  },
  actions: {
    set(context, data) {
      context.commit('set', data)
    },
    cleanup(context) {
      context.commit('cleanup')
    },
  },
  getters: {
    sourceVideoId: state => !state.video ? null : state.video.id,
    video: state => state.video,
    duration: state => state.duration,
    mode: state => state.mode,
    oneToOneData: state => state.oneToOneData,
    oneToManyData: state => state.oneToManyData,
    getBaseChunkData: (state, getters) => {
      return (time = 0) => ({
        ranges: [
          [time, time+10],
        ],
        title: '',
        tag: [],
        series: [], // item(series_group_id, ep)
        news: [], // news ids
      })
    },
    playRange: state => state.playRange,
  },
}
